import { fmtMoney } from "@/lib/constants";

export default function RevenueStatusBar({ stats }) {
  if (!stats) return null;
  const items = [
    { label: "Closed MRR", value: `${fmtMoney(stats.closed_mrr)}/mo`, color: "#6EE7B7" },
    { label: "Setup fees closed", value: fmtMoney(stats.setup_fees_closed), color: "#FFFFFF" },
    { label: "Open MRR pipeline", value: `${fmtMoney(stats.open_mrr)}/mo`, color: "#A78BFA" },
    { label: "Needs outreach", value: stats.needs_outreach, color: "#FCD34D" },
    { label: "Follow-ups", value: stats.follow_ups, color: "#67E8F9" },
    { label: "Lost", value: stats.lost, color: "#FCA5A5" },
  ];
  return (
    <div className="gos-card px-6 py-4 fade-up" data-testid="revenue-status-bar">
      <div className="flex flex-wrap items-center gap-x-8 gap-y-3">
        <span className="eyebrow">Revenue Status</span>
        {items.map((it) => (
          <div key={it.label} className="flex items-center gap-2">
            <span className="text-xs text-slate-400">{it.label}:</span>
            <span className="font-mono-g text-sm font-bold" style={{ color: it.color }}>
              {it.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
